module.exports = __webpack_public_path__ + "img/bowel-cancer-leaflet.301ab87e.jpg";